import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { getPodcastData } from '../../actions';
import { bookImage, singular, sleep } from '../../lib/utils';
import AppCustomLink from './AppCustomLink';
import { minImageWidth, spacing } from '../../lib/theme';

class HighlightsCards extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collectionIdsSorted: [],
            collectionIdsSortedMap: {},
            collectionIdsToFetchMapFin: [],
        }
    }
    componentDidMount() {
        // const { userDetails, episodeBookmarks } = this.props;
        this.fetchData();
    }

    componentDidUpdate(prevProps) {
        const { bookmarkCollectionIds } = this.props;
        if (prevProps && (typeof bookmarkCollectionIds !== 'undefined' && bookmarkCollectionIds !== prevProps.bookmarkCollectionIds)) {
            if (bookmarkCollectionIds && Object.keys(bookmarkCollectionIds).length > 0) {
                // this.props.fetchAllEpisodeBookmarks(userDetails.uid);
                this.fetchData();
            }
        }
    }

    fetchData = async () => {
        const { highlightsMap, bookmarkCollectionIds } = this.props;
        let collectionIdsMap = {};
        let collectionIdsToFetchMap = {};

        Object.values(highlightsMap).forEach((value) => {
            const collectionId = value['collectionId'];
            if (collectionId !== undefined && collectionId !== null) {
                const highlightsMap = value['highlights'] || {};
                if (Object.keys(highlightsMap).length > 0) {
                    collectionIdsMap[collectionId] = (collectionIdsMap[collectionId] || 0) + Object.keys(highlightsMap).length;
                    collectionIdsToFetchMap[collectionId] = true;
                }
            }
        });

        Object.keys(bookmarkCollectionIds).forEach((key) => {
            const collectionId = key;
            if (collectionId !== undefined && collectionId !== null) {
                collectionIdsToFetchMap[collectionId] = true;
            }
        });

        // let collectionIdsSortedMap = collectionIdsMap;
        let collectionIdsSorted = Object.keys(collectionIdsMap);
        let collectionIdsToFetchMapFin = Object.keys(collectionIdsToFetchMap);

        console.dir('collectionIdsSorted');
        console.dir(collectionIdsSorted);
        await sleep(300);
        this.setState({
            collectionIdsSortedMap: collectionIdsMap, collectionIdsSorted,
            collectionIdsToFetchMapFin
        })

        collectionIdsToFetchMapFin.forEach((element) => {
            this.props.getPodcastData(element);
        });
    }

    render() {
        const { dbPodcastState, bookmarkCollectionIds } = this.props;
        const { collectionIdsToFetchMapFin, collectionIdsSortedMap } = this.state;
        // final Map podcasts = vm.dbPodcastState;
        const collectionIdsSortedFin = [
            ...collectionIdsToFetchMapFin
        ];
        collectionIdsSortedFin.sort((el1, el2) =>
            ((dbPodcastState[el1] ?? {})['collectionName'] ?? '')
                .localeCompare(((dbPodcastState[el2] ?? {})['collectionName'] ?? '')));
        return (
            <div>

                <div className='flex'>
                    {collectionIdsSortedFin.map((collectionId, ind) => (
                        <div key={ind} style={{ marginRight: `${spacing('xl')}`, marginBottom: '2em', cursor: 'pointer' }}>
                            {dbPodcastState[collectionId] && <AppCustomLink
                                as={`/bookmarks/${collectionId}`}
                                href={`/bookmarks/${collectionId}`}>
                                <a>
                                    {/* <Podcast podcast={dbPodcastState[collectionId] || {}}
                                        marginBottom={'1px'}
                                        showSubscribe={false} size='lg' /> */}
                                    <img src={bookImage(dbPodcastState[collectionId])} alt={`${dbPodcastState[collectionId].collectionName || ''} book`} />

                                    <h4 className='text-center'>
                                        {collectionIdsSortedMap[collectionId] ?? 0} {singular('Highlight', collectionIdsSortedMap[collectionId] ?? 0)}
                                    </h4>
                                    <h4 className='text-center'>
                                        {bookmarkCollectionIds[collectionId] ?? 0} {singular('Bookmark', bookmarkCollectionIds[collectionId] ?? 0)}
                                    </h4>
                                </a>
                            </AppCustomLink>}
                        </div>
                    ))}
                </div>

                <style jsx>
                    {`
                    .flex {
                        display: flex;
                        flex-wrap: wrap;
                        // justify-content: space-between;
                    }

            img {
                width: 100%;
                // min-height: 120px; // so that images load better.
                width: 160px;
                min-width: ${minImageWidth};
                border-radius: ${spacing('md')};
                // box-shadow: 0 8px 8px rgba(0,0,0,0.30), 0 4px 4px rgba(0,0,0,0.22);
                box-shadow: 0 20px 40px 0 rgba(0,11,40,.14);
                margin-bottom: 8px;
              }
                        `}
                </style>
            </div>
        )
    }
}

HighlightsCards.propTypes = {
    dbPodcastState: PropTypes.object,
    loadingUserDetails: PropTypes.bool,
    // fetchError: PropTypes.object,
    userDetails: PropTypes.object,
    bookmarkCollectionIds: PropTypes.object,
    highlightsMap: PropTypes.object,
    getPodcastData: PropTypes.func,
    // getEpisodeReviews: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        dbPodcastState: state.dbPodcastState,
        // fetchError: state.errorsState,
        // episodeBookmarks: state.episodeBookmarks,
        // highlightsMap: state.highlights,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getPodcastData: bindActionCreators(getPodcastData, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(HighlightsCards);